import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { theme } from '../../styles/theme';

interface NavItem {
    path: string;
    icon: string;
    label: string;
}

const navItems: NavItem[] = [
    { path: '/', icon: '🏠', label: 'Home' },
    { path: '/category/russia', icon: '🪆', label: 'Россия' },
    { path: '/quests', icon: '🎯', label: 'Quests' },
    { path: '/profile', icon: '👤', label: 'Profile' },
];

const BottomNav: React.FC = () => {
    const location = useLocation();

    // Hide nav on game screen
    if (location.pathname.startsWith('/play/')) {
        return null;
    }

    return (
        <nav style={{
            position: 'fixed',
            bottom: 0,
            left: 0,
            right: 0,
            background: theme.colors.cardBg,
            borderTop: `1px solid ${theme.colors.cardBorder}`,
            display: 'flex',
            justifyContent: 'space-around',
            alignItems: 'center',
            padding: '8px 0',
            paddingBottom: 'calc(8px + env(safe-area-inset-bottom))',
            zIndex: 1000,
            boxShadow: '0 -4px 20px rgba(61, 53, 48, 0.1)',
        }}>
            {navItems.map((item) => {
                const isActive = location.pathname === item.path ||
                    (item.path !== '/' && location.pathname.startsWith(item.path));

                return (
                    <Link
                        key={item.path}
                        to={item.path}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            textDecoration: 'none',
                            padding: '8px 12px',
                            borderRadius: theme.borderRadius.md,
                            transition: 'all 0.2s ease',
                            background: isActive ? theme.colors.bgSecondary : 'transparent',
                            minWidth: '60px',
                        }}
                    >
                        <span style={{
                            fontSize: '24px',
                            marginBottom: '2px',
                            filter: isActive ? 'none' : 'grayscale(0.3)',
                            transform: isActive ? 'scale(1.1)' : 'scale(1)',
                            transition: 'all 0.2s ease',
                        }}>
                            {item.icon}
                        </span>
                        <span style={{
                            fontSize: '10px',
                            fontWeight: isActive ? 600 : 500,
                            color: isActive ? theme.colors.primary : theme.colors.textMuted,
                            transition: 'color 0.2s ease',
                        }}>
                            {item.label}
                        </span>
                    </Link>
                );
            })}
        </nav>
    );
};

export default BottomNav;
